export class MetaDataMap {
  private map: Map<string, any[]> = new Map();

  public get(key: string): any[] {
    return this.map.get(key);
  }

  public has(key: string): boolean {
    return this.map.has(key);
  }

  public iterator(): string[] {
    const iteratable: string[] = [];

    for (const [key, values] of this.map) {
      if (key !== 'key') {
        for (const value of values) {
          iteratable.push(`${key}:${value}`);
        }
      }
    }

    return iteratable;
  }

  public set(key: string, value: any[]): this {
    this.map.set(key, value);

    return this;
  }
}
